import { gql } from '@apollo/client'
import { NOTIFICATION_FIELDS } from './fragments/notification'

export const DISMISS_NOTIFICATION = gql`
  ${NOTIFICATION_FIELDS}
  mutation dismissNotification($id: ID!) {
    dismissNotification(id: $id) {
      ...NotificationFields
    }
  }
`
